(function() {
    'use strict';
a3_cabin_reports.factory('SaCrewAssessmentMemberFactory', SaCrewAssessmentMemberFactory)
    
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CrewAssessmentMemberFactory
    * @description 
    *   Initializes new Crew Assessment Members
    * @ngInject
    */           
function SaCrewAssessmentMemberFactory() {

        /**
        * Initialize the Crew Assessment Member
        * @memberof CrewAssessmentMemberFactory
        */
		function CrewAssessmentMember() {
			this.CrewAimsId = null;
			this.CrewId = null;
			this.Name = null;
			this.IsCompleted = false;
			this.IsValid = true;
			this.IsOverride = false;
			this.IsManual = false;
			this.IsExist = false;
            this.Review = null;
			this.assessmentItems = [];
            this.IsOutdated = false;
            this.EndPeriod = null;
		}

		var service = 
		{
			newMember : newMember
		}

        /**
         * Create New Crew Assessment Member
         * @memberof CrewAssessmentMemberFactory
         * @returns {object} CrewAssessmentMember 
         */
		function newMember() {
			return new CrewAssessmentMember();
		}

	return service;
}
    
})();